/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartData } from "../data/useChartData";
import { useHighchartTransformer } from "../transformers/useHighchartTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { ComponentTitle } from "../../../components/ComponentTitle";

export const ComponentChart: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResult$);
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(null, context.loading$);

  const chartData = useChartData(olapResult);
  const highchartData = useHighchartTransformer(chartData);

  const isExportMode = window["exportMode"];

  if (isExportMode) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }

  const sourceTitle = isExportMode ? `Source: ${source}` : "\u00A0";
  return (
    <>
      <ComponentTitle>&nbsp;</ComponentTitle>
      <ComponentSourcetitle>{sourceTitle}</ComponentSourcetitle>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
    </>
  );
};
